import React from 'react';
var WizardSkeleton = function () { return (React.createElement("div", { className: "wizard" },
    React.createElement("div", { className: "p-3" },
        React.createElement("div", { className: "row m-0", style: { height: 100 } },
            React.createElement("div", { className: "skeleton-line h-100 flex-fill mr-1" }),
            React.createElement("div", { className: "skeleton-line h-100 flex-fill mt-0 mr-1" }),
            React.createElement("div", { className: "skeleton-line h-100 flex-fill mt-0 mr-1" }),
            React.createElement("div", { className: "skeleton-line h-100 flex-fill mt-0" })),
        React.createElement("div", { className: "py-2" },
            React.createElement("div", { className: "skeleton-line h-100 flex-fill", style: { minHeight: 440 } })),
        React.createElement("div", { className: "row modalfooter" },
            React.createElement("div", { className: "col-6" },
                React.createElement("div", { className: "pt-3 wizard-navigation-buttons-container" },
                    React.createElement("button", { className: "skeleton-line skeleton-h-xl skeleton-w-lg btn" }))),
            React.createElement("div", { className: "col-6" },
                React.createElement("div", { className: "mt-3 wizard-footer d-flex justify-content-end" },
                    React.createElement("button", { className: "skeleton-line skeleton-h-xl skeleton-w-lg btn" }),
                    React.createElement("button", { className: "skeleton-line skeleton-h-xl skeleton-header skeleton-w-lg btn mt-0 ml-2" }))))))); };
export default React.memo(WizardSkeleton);
